import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, signal } from "@angular/core";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";
import { CoursePricing, resolveCoursePricing } from "src/utils/course-pricing";

@Component({
  selector: "app-course-recommend-item",
  imports: [
    SharedModule,
    PipesModule,
    NgbTooltipModule,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: "./course-recommend-item.component.html",
  styleUrl: "./course-recommend-item.component.scss",
})
export class CourseRecommendItemComponent implements OnInit {
  @Input() data: any;

  fileUrl = environment.apiFileUrl;
  pricing = signal<CoursePricing>({
    hasDiscount: false,
    price: 0,
    originalPrice: 0,
  });

  ngOnInit(): void {
    this.pricing.set(resolveCoursePricing(this.data));
  }

  isArray(key: any) {
    return Array.isArray(key);
  }
}
